import { render, staticRenderFns } from "./modal-login.component.html?vue&type=template&id=0bd0c7dc&scoped=true&"
import script from "./modal-login.component.ts?vue&type=script&lang=ts&"
export * from "./modal-login.component.ts?vue&type=script&lang=ts&"
import style0 from "./modal-login.component.scss?vue&type=style&index=0&id=0bd0c7dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0c7dc",
  null
  
)

export default component.exports